const carouselItems = [
  {
    title: '暑期追剧指南',
    desc: '精选今夏最值得追的十部热播剧，从古装到现代，总有一部适合你',
    tag: '编辑推荐',
    img: 'https://readdy.ai/api/search-image?query=Summer%20entertainment%20theme%20with%20warm%20sunset%20colors%2C%20cozy%20living%20room%20with%20large%20TV%20screen%20showing%20cinematic%20imagery%2C%20relaxed%20atmosphere%2C%20golden%20hour%20lighting%2C%20lifestyle%20photography%20style&width=800&height=450&seq=carousel-topic-01&orientation=landscape',
  },
  {
    title: '国产高分神剧合集',
    desc: '豆瓣8.5分以上的国产剧一网打尽，每一部都不容错过',
    tag: '高分精选',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20drama%20award%20collection%20theme%2C%20elegant%20display%20of%20golden%20trophies%20and%20film%20reels%2C%20warm%20spotlight%20effect%2C%20premium%20cinematic%20atmosphere%2C%20dark%20theater%20background%20with%20gold%20accents&width=800&height=450&seq=carousel-topic-02&orientation=landscape',
  },
  {
    title: '韩剧必看清单',
    desc: '从经典到最新，韩剧爱好者不可错过的精选片单',
    tag: '韩流精选',
    img: 'https://readdy.ai/api/search-image?query=Korean%20drama%20collection%20aesthetic%2C%20soft%20pastel%20pink%20and%20cream%20color%20palette%2C%20romantic%20spring%20cherry%20blossom%20atmosphere%2C%20elegant%20minimalist%20composition%2C%20dreamy%20cinematic%20visual&width=800&height=450&seq=carousel-topic-03&orientation=landscape',
  },
  {
    title: '院线新片速递',
    desc: '最新上线的院线电影高清版，躺在家里也能看大片',
    tag: '新片上线',
    img: 'https://readdy.ai/api/search-image?query=Modern%20cinema%20theater%20interior%20with%20red%20velvet%20seats%2C%20large%20empty%20screen%20with%20soft%20glow%2C%20luxurious%20atmosphere%2C%20warm%20ambient%20lighting%2C%20premium%20movie%20experience%20visual&width=800&height=450&seq=carousel-topic-04&orientation=landscape',
  },
  {
    title: '悬疑烧脑片单',
    desc: '反转不断的悬疑剧和烧脑电影，考验你的推理能力',
    tag: '悬疑专场',
    img: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20noir%20theme%2C%20dark%20rainy%20alley%20with%20single%20streetlamp%2C%20shadowy%20figure%20silhouette%2C%20atmospheric%20fog%2C%20cinematic%20detective%20story%20visual%2C%20deep%20blues%20and%20warm%20amber%20contrast&width=800&height=450&seq=carousel-topic-05&orientation=landscape',
  },
  {
    title: '经典老片重温',
    desc: '那些年我们追过的经典电视剧和电影，满满的回忆杀',
    tag: '怀旧经典',
    img: 'https://readdy.ai/api/search-image?query=Vintage%20film%20nostalgia%20theme%2C%20old%20film%20projector%20with%20warm%20glowing%20light%2C%20retro%20cinema%20aesthetic%2C%20aged%20film%20strips%2C%20warm%20sepia%20tone%2C%20nostalgic%20atmosphere%2C%20classic%20movie%20memories&width=800&height=450&seq=carousel-topic-06&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">精选专题</h2>
          <p className="text-sm text-foreground-500">精心策划的影视专题合集，发现更多好内容</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselItems.map((item, idx) => (
            <div key={idx} className="group cursor-pointer rounded-2xl overflow-hidden bg-background-50 border border-background-200 hover:border-primary-200 transition-colors">
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={`${item.title} - ${item.tag}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 text-xs font-medium bg-primary-500/90 text-background-50 rounded-full">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-heading font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}